/* loaded by smart-asset */
export default require("./assets/isometric-cage-na.i.svg")